import { TypedString } from 'types';

type Props = {
  videoId: TypedString<'youtube-video-id'>;
  autoPlay?: boolean;
  showRelatedVideos?: boolean;
};

export function getYoutubeVideoSrc({
  videoId,
  autoPlay,
  showRelatedVideos,
}: Props) {
  const options = [
    'enablejsapi=1',
    `autoplay=${autoPlay ? 1 : 0}`,
    `origin=${typeof window !== 'undefined' ? window.location.origin : ''}`,
    `rel=${showRelatedVideos ? 1 : 0}`,
  ];

  return `https://www.youtube.com/embed/${videoId}?${options.join('&')}`;
}
